export const commonContent = {
    NAME: '',
    SHORTNAME:'',
    AUTHORIZED_USER_TEXT: 'Co-Owner',
    BENEFECIARY_TEXT: 'Survivorship Benefeciary',
    // Do not change the &#8204; characters included in the address label below. It is to avoid browser auto fill issues.
    ADDRESS_LABEL: 'Start typing to select the address',
    LANDINGPAGE: {
		TITLE: 'Here’s What You’ll Need to Open an Account',
		DESCRIPTION: '<ul class="checkmark">'+
                    '<li>ID for Identity Verification</li>'+
                    '<li>Social Security Number</li>'+
                    '<li>Account Information for Initial Deposit</li>'+
                '</ul>',
        GETSTARTEDBUTTONLABEL: 'Get Started',
	},
    MESSAGES: {
        OFFERS: {
            NO_OFFER_HARD_DECLINE: {
                TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                MESSAGE: `Based on the information provided, we are unable to open an account for you at this time. If you have questions, please call us at 770-534-4255.`
            },
            NO_OFFER_SOFT_DECLINE: {
                TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                MESSAGE: `Based on the information provided, we are unable to open an account for you at this time. If you have questions, please call us at 770-534-4255.`
            },
            NO_OFFER: {
                TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                MESSAGE: `Based on the information provided, we are unable to open an account for you at this time. If you have questions, please call us at 770-534-4255.`
            },
            NO_OFFER_NO_HIT: {
                TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                MESSAGE: `Based on the information provided, we are unable to open an account for you at this time. If you have questions, please call us at 770-534-4255.`
            }
        }
    },
    PREFILL:{
        TERMS: 'You authorize your wireless carrier to use or disclose information about your account and your wireless device, if available, to us or our service provider for the duration of your business relationship, solely to help them identify you or your wireless device and to prevent fraud. See our Privacy Policy for how we treat your data.'
    },
    ABOUT: {
        TITLE: 'Select an Account That Meets Your Financial Needs',
        HEADLINE: 'Open your account in as little as 2 minutes.',
        MOBILE_HEADLINE: 'Open your account in as little as 2 minutes.',
        SUB_HEADLINE: 'Select Account. Complete KYC. eSignature. Fund your Account. Done!',
        COBORROWER: {
            HEADLINE: 'Tell me about your Joint Account Holder',
            SUB_HEADLINE: 'Joint Account holder will have the same access and rights to your account as you do.'
        },
        APPLICANT_FORM: {
            LOAN_PURPOSE: 'What type of account do you want to open?',
            MEMBERSHIP_ELIGIBILITY: 'I am eligible for an account because:',
            MEMBERSHIP_ELIGIBILITY_LINK_TEXT: 'Click here to determine Eligibility',
            ADDRESS_PARTIAL_LABEL: 'Start typing to select the ',
            FIRST_NAME_FIELD: {
              PLACEHOLDER: '',
              ERROR_MESSAGE: ''
            },
            SUBMIT_BUTTON: {
                DEFAULT: 'Open My Account',
                SUBMIT: 'Submit',
                CONTINUE: 'Continue',
                PROCESSING: 'Processing...'
            }
        },
        CD_MINIMUM_BALANCE_TEXT: 'minimum daily balance to obtain APY',
    },
    TRADE: {
        HEADLINE: '',
    },
    THANK_YOU: {
        CASH_APPLICATION: {
            HEADER: 'Do you have another car? Do you want to save on your monthly loan payments for that car?',
            SUB_HEADER: 'See Your Refinance Rate Now, without Impacting Your Credit Score. It only takes 2 minutes to find out',
        }
    },
    OFFER: {
        ERROR_SITUATION: {
            HEADER: 'Additional information required to process your request.',
            SUB_HEADER: 'Thank you for submitting your application. We need additional information before you can see your offer. ' +
                'Please contact your dedicated Advisor at the number listed above' +
                ' so that we can get you the loan that meets your needs.'
        }
    },
    REVIEW: {
        HEADLINE: 'Almost done!! We need additional information to complete your account creation.',
        DL: {
            PLACEHODLER1: 'Driver License',
            PLACEHODLER2: 'Driver\'s License',
        }
    },
    TERMS_POP_UP: {
        TEXT_BELOW_BUTTON: 'On \"Accept & Continue\", you will also receive these disclosures to the email address you used on this application for future reference.',
    },
    PROVISION: {
        DECISION: {
            TITLE: `Great news! You're eligible to open your account.`
        },
        IDPAL: {
            TITLE: 'Your application is ready for ID Verification on your mobile phone.',
            DESCRIPTION: 'An ID Verification link has been sent to {{applicantPhoneNumber}} and {{applicantEmail}}.<br><b>Please use your mobile device to open the link.</b>',
            ADDITIONAL_DESCRIPTION: ''
        },
        'THANKYOU-INREVIEW': {
            TITLE: 'Your Application is Under Review',
            MESSAGE: 'We will contact you within 1 business day regarding the status of your application.'
        },
        'THANKYOU-ACCOUNTSUBMITFAILED': {
            TITLE: 'Your Application is Under Review',
            MESSAGE: 'We will contact you within 1 business day regarding the status of your application.'
        },
        'THANKYOU-DOWNLOAD': {
            TITLE: 'Your Application is Under Review',
            MESSAGE: 'We will contact you within 1 business day regarding the status of your application.',
            MESSAGE_FALLBACK: 'You have successfully opened your account under {{name}} with Account number {{accountNumber}}.'
        },
        'THANKYOU-DECLINE': {
            TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
            MESSAGE: ''
        },
        EXCEPTION: {
            TITLE: 'Oops, something unexpected happened!',
            MESSAGE: 'Our expert  Representatives will be able to take care of you. Please call ' +
                'the number listed above to speak to us.'
        },
        THANKYOU: {
            TITLE: 'Your Application is Under Review',
            MESSAGE: 'We will contact you within 1 business day regarding the status of your application.'
        },
    },
    ZIP_LABEL: 'Zip Code',
    PAYMENT_METHOD: {
        CREDIT_CARD: {
            SHORT_DESCRIPTION: 'Use a credit card to fund your account.'
        },
        DEBIT_CARD: {
            SHORT_DESCRIPTION: 'Use a debit card to fund your account.'
        },
        EXTERNAL_BANK_ACCOUNT: {
            SHORT_DESCRIPTION: 'Fund your account by transferring money from another financial institution.'
        },
        INTERNAL_BANK_ACCOUNT: {
            SHORT_DESCRIPTION: 'Transfer funds from your existing {{NAME}} Account.'
        }
    }
};
